import { Coins } from "lucide-react";
import * as React from "react";
import { cn } from "../lib/utils.js";

/**
 * CreditChip (W-3): "AXA credit {amount} available" under the value at
 * risk. A highlight fill with a coin icon; never a status (no status
 * colours). The label arrives translated and formatted.
 */

export interface CreditChipProps extends React.ComponentProps<"p"> {
  label: string;
}

function CreditChip({ label, className, ...props }: CreditChipProps) {
  return (
    <p
      data-slot="credit-chip"
      className={cn(
        "inline-flex w-fit items-center gap-1.5 rounded-md bg-accent px-2 py-0.5 text-sm font-semibold text-accent-foreground",
        className,
      )}
      {...props}
    >
      <Coins aria-hidden="true" className="size-4 shrink-0" />
      <span>{label}</span>
    </p>
  );
}

export { CreditChip };
